const Orders = () => {
   return (
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
         <path stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.9" d="M14 13.961h3.57M14 10.039h3.57M13.063 17.885h4.507">
         </path>
         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.9" d="M18.923 3.5H21v18.308H3V3.5h2.077"></path>
         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.9" d="M8.076 2.192v3.923h2.616a1.308 1.308 0 012.615 0h2.616V2.192H8.076zM6.487 14.942c0 .916.72 1.635 1.635 1.635h.654c.915 0 1.634-.72 1.634-1.635 0-2.288-3.923-.98-3.923-3.269 0-.915.72-1.634 1.635-1.634h.654c.915 0 1.634.719 1.634 1.634">
         </path>
         <path fill="currentColor" d="M7.498 18.076a.95.95 0 101.9 0h-1.9zm0-1.5v1.5h1.9v-1.5h-1.9zM9.398 8.543a.95.95 0 00-1.9 0h1.9zm0 1.496V8.543h-1.9v1.496h1.9z">
         </path>
      </svg>
   )
}
export default Orders